export const controlChangeMessages = {
  "0": "Bank Select",
  "1": "Modulation Wheel",
  "2": "Breath Controller",
  "3": "Undefined",
  "4": "Foot Controller",
  "5": "Portamento Time",
  "6": "Data Entry",
  "7": "Channel Volume",
  "8": "Balance",
  "9": "Undefined",
  "10": "Pan",
  "11": "Expression Controller",
  "12": "Effect Control 1",
  "13": "Effect Control 2",
  "14": "Undefined",
  "15": "Undefined",
  "16": "General Purpose Controller 1",
  "17": "General Purpose Controller 2",
  "18": "General Purpose Controller 3",
  "19": "General Purpose Controller 4",
  "20": "Undefined",
  "21": "Undefined",
  "22": "Undefined",
  "23": "Undefined",
  "24": "Undefined",
  "25": "Undefined",
  "26": "Undefined",
  "27": "Undefined",
  "28": "Undefined",
  "29": "Undefined",
  "30": "Undefined",
  "31": "Undefined",

  "32": "Bank Select",
  "33": "Modulation Wheel",
  "34": "Breath Controller",
  "35": "Undefined",
  "36": "Foot Controller",
  "37": "Portamento Time",
  "38": "Data Entry",
  "39": "Channel Volume",
  "40": "Balance",
  "41": "Undefined",
  "42": "Pan",
  "43": "Expression Controller",
  "44": "Effect Control 1",
  "45": "Effect Control 2",
  "46": "Undefined",
  "47": "Undefined",
  "48": "General Purpose Controller 1",
  "49": "General Purpose Controller 2",
  "50": "General Purpose Controller 3",
  "51": "General Purpose Controller 4",
  "52": "Undefined",
  "53": "Undefined",
  "54": "Undefined",
  "55": "Undefined",
  "56": "Undefined",
  "57": "Undefined",
  "58": "Undefined",
  "59": "Undefined",
  "60": "Undefined",
  "61": "Undefined",
  "62": "Undefined",
  "63": "Undefined",

  "64": "Damper Pedal",
  "65": "Portamento On Off",
  "66": "Sostenuto",
  "67": "Soft Pedal",
  "68": "Legato Footswitch",
  "69": "Hold 2",
  "70": "Sound Controller 1",
  "71": "Sound Controller 2",
  "72": "Sound Controller 3",
  "73": "Sound Controller 4",
  "74": "Sound Controller 5",
  "75": "Sound Controller 6",
  "76": "Sound Controller 7",
  "77": "Sound Controller 8",
  "78": "Sound Controller 9",
  "79": "Sound Controller 10",
  "80": "General Purpose Controller 5",
  "81": "General Purpose Controller 6",
  "82": "General Purpose Controller 7",
  "83": "General Purpose Controller 8",
  "84": "Portamento Control",
  "85": "Undefined",
  "86": "Undefined",
  "87": "Undefined",
  "88": "High Resolution Velocity Prefix",
  "89": "Undefined",
  "90": "Undefined",
  "91": "Effects 1 Depth",
  "92": "Effects 2 Depth",
  "93": "Effects 3 Depth",
  "94": "Effects 4 Depth",
  "95": "Effects 5 Depth",
  "96": "Data Increment",
  "97": "Data Decrement",
  "98": "Non Registered Parameter Number LSB",
  "99": "Non Registered Parameter Number MSB",
  "100": "Registered Parameter Number LSB",
  "101": "Registered Parameter Number MSB",
  "102": "Undefined",
  "103": "Undefined",
  "104": "Undefined",
  "105": "Undefined",
  "106": "Undefined",
  "107": "Undefined",
  "108": "Undefined",
  "109": "Undefined",
  "110": "Undefined",
  "111": "Undefined",
  "112": "Undefined",
  "113": "Undefined",
  "114": "Undefined",
  "115": "Undefined",
  "116": "Undefined",
  "117": "Undefined",
  "118": "Undefined",
  "119": "Undefined",
  "120": "All Sound Off",

  "121": "Reset All Controllers",
  "122": "Local Control On Off",
  "123": "All Notes Off",
  "124": "Omni Mode Off",
  "125": "Omni Mode On",
  "126": "Mono Mode On",
  "127": "Poly Mode On"
}
